export enum ClientTaskRejectionReason {
  ignorePatient = 'ignore_patient',
  ignorePrescriber = 'ignore_prescriber',
  ignorePatientPrescriber = 'ignore_patient_prescriber',
}
